<div class="filter-bar">
  <ng-container *ngIf="showAddButton">
    <div class="filter-bar-actions">
      <pa-button
        [icon]="addButtonIcon || undefined"
        [label]="addButtonLabel"
        [severity]="addButtonSeverity"
        (click)="handleAddClick($event)"
      ></pa-button>

      <ng-container *ngFor="let button of actionButtons">
        <pa-button
          *ngIf="isButtonVisible(button)"
          [icon]="button.icon"
          [label]="button.showLabel ? button.label : null"
          [pTooltip]="button.tooltip || null"
          tooltipPosition="top"
          (click)="button.action()"
          [severity]="'secondary'"
          variant="outlined"
        >
        </pa-button>
      </ng-container>

      <pa-context-menu
        *ngIf="menuActionItems.length"
        [items]="menuActionItems"
        icon="pi pi-ellipsis-v"
        severity="secondary"
        size="normal"
      ></pa-context-menu>
    </div>

    <div *ngIf="showFilterButton" class="divider"></div>
  </ng-container>

  <div class="filter-bar-filters-block" [ngClass]="{ 'no-chips': isMobileView }" *ngIf="showFilterButton">
    <pa-button
      icon="pi pi-filter"
      severity="secondary"
      [styleClass]="'filter-bar-filter-button'"
      label="Фильтр"
      [badge]="config?.count ?? 0"
      (click)="handleFilterClick()"
    >
    </pa-button>

    <ng-container *ngIf="filtersConfigForChips && filterResultForChips">
      <app-chip-filters
        [filtersConfig]="filtersConfigForChips"
        [filterResult]="filterResultForChips"
        [removable]="true"
        (remove)="handleChipRemove($event)"
        (chipClick)="handleChipClick($event)"
      ></app-chip-filters>
    </ng-container>
  </div>
</div>
